import React from 'react';
import { View, StyleSheet } from 'react-native';
import { AppHeader } from './AppHeader';
import { NETFLIX_COLORS } from '../theme/netflixTheme';

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps): JSX.Element {
  return (
    <View style={styles.container}>
      <AppHeader />
      <div style={mainContentStyle}>
        <View style={styles.content}>
          {children}
        </View>
      </div>
    </View>
  );
}

const mainContentStyle: React.CSSProperties = {
  maxWidth: '1400px',
  margin: '0 auto',
  width: '100%',
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: NETFLIX_COLORS.background,
  },
  content: {
    flex: 1,
  },
});
